import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import GridContainer from "components/Grid/GridContainer.js";
import Summary from "components/Transport/Summary";
import TransportDetail from "./TransportDetail";
import LoadInfo from "views/Widgets/FichaPaciente/LoadInfo";
import moment from "moment-timezone";
import api from "utils/API";
import { setmessageAlert } from "actions/getGlobalAction";
import "moment/locale/es";
moment.locale("es");

const Transport = (props) => {
  const dispatch = useDispatch();
  const [openDetail, setopenDetail] = useState(null);
  const [initialCharge, setinitialCharge] = useState(true);
  const [driverRow, setdriverRow] = useState([]);
  const [driverDict, setdriverDict] = useState({});
  const [vehicleRow, setvehicleRow] = useState([]);
  const [vehicleDict, setvehicleDict] = useState({});
  const [patientDict, setpatientDict] = useState({});
  const [packagePending, setpackagePending] = useState(0);
  const [packageToDayPending, setpackageToDayPending] = useState(0);
  const [packageWeekPending, setpackageWeekPending] = useState(0);
  const [changes, setChanges] = useState(true);

  const lastCheckRef = useRef(null);

  const [loading, setloading] = useState(false);

  useEffect(() => {
    if (initialCharge){
      initialData();
    }
  });

  useEffect(() => {
    if (changes) {
      fetchResumen();
    }
  }, [changes]);

  useEffect(() => {
    setInterval(() => setChanges(true), 300000);
  }, []);

  const fetchResumen = () => {
    setChanges(false);
    const params = {};
    if (lastCheckRef.current) {
      params.nuevas_desde = lastCheckRef.current;
    }
    api.get("api/transporte/solicitudes/estado/Activas/resumen/", { params }).then(response => {
      const data = response.data;
      setpackagePending(data.pendiente);
      setpackageToDayPending(data.pendiente_hoy);
      setpackageWeekPending(data.pendiente_semana);

      const nuevas = data.nuevas || [];
      if (lastCheckRef.current && nuevas.length > 0) {
        const ids = nuevas.reduce((accum, obj) => `${accum}, ${obj.id}`, "");
        setmessageAlert(dispatch, `Tiene ${nuevas.length} solicitudes nuevas que requieren su atención (${ids})`, "success");
      }
      lastCheckRef.current = new Date().toISOString();
      setloading(true);
    });
  };


  const initialData = () => {
    setinitialCharge(false);

    const requestDrivers = api.get("api/transporte/solicitudes/despacho/conductores/");
    const requestVehicle = api.get("api/vehiculos/");
    const requestPatient = api.get("api/paciente");
    Promise.all([
      requestDrivers,
      requestVehicle,
      requestPatient,
    ]).then((request) => {
      const tempDriverRow = request[0].data;
      const tempVehicleRow = request[1].data;
      setdriverRow(tempDriverRow);
      setdriverDict(request[0].data.reduce((accum, obj) => ({
        ...accum,
        [obj.id]: obj
      }), {}));
      setvehicleRow(tempVehicleRow);
      setvehicleDict(request[1].data.reduce((accum, obj) => ({
        ...accum,
        [obj.id]: obj
      }), {}));
      setpatientDict(request[2].data.reduce((accum, obj) => ({
        ...accum,
        [obj.id]: obj
      }), {}));
      setloading(true);
    });
  };

  return (
    <div>
      {openDetail ?
        <TransportDetail
          setopenDetail={setopenDetail}
          driverRow={driverRow}
          driverDict={driverDict}
          vehicleRow={vehicleRow}
          vehicleDict={vehicleDict}
          patientDict={patientDict}
          changes={changes}
          setChanges={setChanges}
        />
      :
      <GridContainer item
        direction="row"
        justify="space-evenly"
        alignItems="center"
        style={{height: "330px"}}
        xs={12}
      >
        {loading ?
        <Summary
          setopenDetail={setopenDetail}
          packagePending={packagePending}
          packageToDayPending={packageToDayPending}
          packageWeekPending={packageWeekPending}
        />
        :
        <LoadInfo
          title={"Cargando información ..."}
        />
      }
      </GridContainer>
      }
    </div>
  );
};

export default Transport;
